<ng-container *ngIf="!imgLoaded">
  <p class="placeholder-glow">
    <span class="placeholder col-12 w-100"></span>
  </p>
</ng-container>
<div class="main-content" *ngIf="imgLoaded">
  <div class="inbt-category" *ngIf="subcatData && subcatData.length != 0">
    <div class="product-banner" id="caraousel-scroll">
      <ng-container *ngIf="bannerlist && bannerlist?.length == 0; else loadingWebBannerListContent">
        <p class="placeholder-glow">
          <span class="placeholder col-12 w-100"></span>
        </p>
      </ng-container>
      <ng-template #loadingWebBannerListContent>
        <div #carousel *ngIf="bannerlist" class="position-relative">
          <owl-carousel-o [options]="utils.customOptionsForBanner" (changed)="handleSlideChange($event, 'web')" #owlCar>
            <ng-container *ngFor="let slideData of bannerlist;let i=index">
              <ng-template carouselSlide>
                <a [href]="slideData.ctaLink" (click)="triggerBannerClick(slideData)">
                  <picture>
                    <source [srcset]="slideData.mobileImageFile" media="(max-width: 768px)">
                    <source [srcset]="slideData.webImageFile" media="(min-width: 769px)">
                    <img [src]="slideData.webImageFile" width="100" height="100" class="h-auto" role="button" [loading]="i==0?'eager':'lazy'"
                    [src]="slideData.webImageFile"
                    [alt]="slideData.altTag" [attr.rel]="i == 0 ? 'preload' : null">
                  </picture>
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

            <!-- Navigation Buttons -->
            <!-- <button class="owl-nav d-flex justify-content-center align-items-center owl-prev" (click)="owlCar.prev()">
              <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40" focusable="false" aria-hidden="true" data-di-res-id="ca1abdf8-d437167" data-di-rand="1725952672698">
                <g fill="none" fill-rule="evenodd">
                  <g>
                    <circle cx="20" cy="20" r="20"></circle>
                    <g fill-rule="nonzero">
                      <path d="M15.179 3.173L16.043 4.077 7.765 12 16.043 19.923 15.179 20.827 5.957 12z" transform="translate(8 8)" fill="#ffffff"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button class="owl-nav d-flex justify-content-center align-items-center owl-next" (click)="owlCar.next()">
              <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40" focusable="false" aria-hidden="true" data-di-res-id="72a6da9d-f8bd046d" data-di-rand="1725952672699">
                <g>
                  <circle cx="20" cy="20" r="20"></circle>
                  <g fill-rule="nonzero">
                    <path d="M7.957 4.077L8.821 3.173 18.043 12 8.821 20.827 7.957 19.923 16.235 12z" transform="translate(8 8)" fill="#ffffff"></path>
                  </g>
                </g>
              </svg>    
            </button> -->
        </div>
      </ng-template>
    </div>
    <div class="power-solution" *ngIf="subcatData && subcatData.landingPageDetail">
      <div class="container">
        <div class="row justify-content-md-between">
          <div class="col-md-3">
            <h1 class="text-transform-none">
              {{subcatData.landingPageDetail.brandSubCategoryName?subcatData.landingPageDetail.brandSubCategoryName:'SubCategory'}}</h1>
          </div>
          <div class="col-md-8 description">
            <p class="textJustify">{{subcatData.landingPageDetail && subcatData.landingPageDetail.landingPageDescription
              ?subcatData.landingPageDetail.landingPageDescription:'N/A'}}</p>
            <div class="btn-wrap">
             <a [routerLink]="getPlpRouteLink('')" class="primaryBtn nextarrow">
                <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/view.webp'" alt="View | Luminous">
                View all products</a>
              <a routerLink="/catalogue" class="grey-btn nextarrow">
                <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/pdf.webp'" alt="PDF | Luminous"> View catalogue</a>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="load" *ngIf="!subcatData.isSolar">
      <div #carousel *ngIf="utils.screenSizeObj.width >768 && smallWebBannerList" class="position-relative">
        <owl-carousel-o [options]="utils.customOptionsForSmallBanner">
          <ng-container *ngFor="let slideData of smallWebBannerList">
            <ng-template carouselSlide>
              <a [href]="slideData.link" (click)="analyticsService.triggerLoadInitiated(subcatData.landingPageDetail.brandSubCategoryName?subcatData.landingPageDetail.brandSubCategoryName:'SubCategory'); triggerBannerClick(slideData)">
                <img role="button"  loading="lazy" [src]="slideData.image" [alt]="slideData.altTag">
              </a>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
      <div #carousel *ngIf="utils.screenSizeObj.width <=768 && smallMobileBannerList" class="position-relative">
        <owl-carousel-o [options]="utils.customOptionsForSmallBanner">
          <ng-container *ngFor="let slideData of smallMobileBannerList">
            <ng-template carouselSlide>
              <a [href]="slideData.link" (click)="analyticsService.triggerLoadInitiated(subcatData.landingPageDetail.brandSubCategoryName?subcatData.landingPageDetail.brandSubCategoryName:'SubCategory'); triggerBannerClick(slideData)">
                <img role="button"  loading="lazy" [src]="slideData.image" [alt]="slideData.altTag">
              </a>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
    <div class="technology bgWhite" *ngIf="subcatData && subcatData.technologyAttributeMappingDetails && subcatData.technologyAttributeMappingDetails && subcatData.technologyAttributeMappingDetails.technologyAttributeMapping.length">
      <div class="container">
        <div class="tabing">
          <ul>
            <li
              *ngFor="let techData of subcatData.technologyAttributeMappingDetails.technologyAttributeMapping;let i=index"
              [ngClass]="{'active':(selectedTechnologyData ?selectedTechnologyData.technologyName === techData.technologyName :'')}"
              (click)="selectedTechnologyData=techData">
              {{techData.technologyName}}</li>
          </ul>
        </div>
        <div class="tech-details">
          <div class="tech-row">
            <div class="tech-col" *ngFor="let attrData of selectedTechnologyData.attributeDetails">
              <div class="info-wrap">
                <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/inbt-category/info.webp'" alt="Info | Luminous" class="info">
                <div class="overlay">
                  {{attrData.attributeDescription?attrData.attributeDescription:"N/A"}}
                </div>
              </div>
              <img  loading="lazy" [src]="attrData.attributeIcon"  [alt]="attrData.attributeIcon"
                class="main-img">
              <p class="attributeName">{{attrData.attributeName?attrData.attributeName:'N/A'}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="feature-produc bgWhite" *ngIf="productCarousalData && productCarousalData.length">
      <div class="container">
        <h3>Featured Products</h3>
        <app-carousal-page [genericCarousel]="true" [carouselSlideData]="productCarousalData" [isProductCarousel]="true"
          (imageClicked)="onProductClick($event)">
        </app-carousal-page>
      </div>
    </div>

    <div class="product-series" *ngIf="subcatData.subCategorySeriesAttributeMappings && subcatData.subCategorySeriesAttributeMappings.length">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 seriesDataContainer"
            *ngFor="let seriesData of subcatData.subCategorySeriesAttributeMappings;let i=index">
            <div class="regalia-col">
              <div class="product-details">
                <div class="product-img">
                  <img  loading="lazy" [src]="seriesData.seriesImage"
                    [alt]="seriesData.seriesName?seriesData.seriesName:'series image'">
                </div>
                <div class="details">
                  <h3 class="text-transform-none">{{seriesData.seriesName?seriesData.seriesName:'N/A'}}</h3>
                  <div class="product-img">
                    <img  loading="lazy" [src]="seriesData.seriesImage"
                      [alt]="seriesData.seriesName?seriesData.seriesName:'series image'">
                  </div>
                  <ul>
                    <li *ngFor="let attrData of seriesData.attributeDetail">
                      <img loading="lazy" [src]="attrData.attributeIcon" 
                        [alt]="attrData.attributeName?attrData.attributeName:'attribute image'">
                      <span>{{attrData.attributeName?attrData.attributeName:'N/A'}}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="description">
                <p class="textJustify">{{(seriesData.seriesDescription?seriesData.seriesDescription:'N/A')|
                  truncateStr:[445]}}</p>
              </div>

              <div class="btn-wrap btn-series">
                <a role="button" [routerLink]="getPlpRouteLink(seriesData)" class="nextarrow view">View Products</a>
                <a role="button" [routerLink]="getSeriesRouteLink(seriesData)"
                  (click)="triggerSeriesClicked(seriesData)"
                  *ngIf="utils.checkValidityOfGuid(seriesData.seriesLandingPageGuid)">Learn More</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="feature-product">
      <div class="container">
        <app-faq-page
          *ngIf="subcatData && subcatData?.commonSectionDetail &&subcatData?.commonSectionDetail.questionAnswerList &&subcatData?.commonSectionDetail.questionAnswerList.length"
          [faqData]="subcatData.commonSectionDetail.questionAnswerList"></app-faq-page>
      </div>
    </div>
    <div class="watch-video feature-product"
      *ngIf="subcatData && subcatData?.commonSectionDetail && subcatData?.commonSectionDetail.mediaList && subcatData && subcatData?.commonSectionDetail.mediaList.length && showVideoSection">
      <div class="container">
        <h3>Videos to watch</h3>
        <app-carousal-page [genericCarousel]="true" [carouselSlideData]="subcatData?.commonSectionDetail.mediaList">
        </app-carousal-page>
      </div>
    </div>
    <div class="watch-video"
      *ngIf="subcatData && subcatData?.commonSectionDetail && subcatData?.commonSectionDetail?.wordPressBlogList && subcatData && subcatData?.commonSectionDetail?.wordPressBlogList.length">
      <div class="container">
        <h3>Blogs to read</h3>
        <app-carousal-page [genericCarousel]="true"
          [carouselSlideData]="subcatData?.commonSectionDetail?.wordPressBlogList">
        </app-carousal-page>
      </div>
    </div>
  </div>
<app-solar-loan *ngIf="landingPageName === 'solar-loan'"></app-solar-loan>
<app-gem *ngIf="landingPageName === 'gem'"></app-gem>
<app-solar-design *ngIf="landingPageName === 'solar-design'"></app-solar-design>
<div [innerHtml]="structuredData"></div>
